import React from 'react';

import { ReactComponent as WarningIcon } from 'assets/images/general/ic-warning-outline-black.svg';
import style from './SingpassExpired.module.scss';

export default function SingpassExpired() {
    const htmlContent = `Your Singpass data has <span class=${style.text__expired}>expired</span>, but no worries! Please <span class=${style.text__strong}>refresh your data</span> to continue.`;

    return (
        <div className={style.container}>
            <WarningIcon className={style.icon} />
            <div className={style.text} dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </div>
    );
}
